import { createBrowserHistory } from 'history';

export default createBrowserHistory();

function locationAs(path) {
  window.history.pushState("", "", path);
}

export { locationAs };
